__turbopack_context__.v({
  "core": "ThemeToggle-module-scss-module__dHZAwW__core",
  "icon": "ThemeToggle-module-scss-module__dHZAwW__icon",
  "maskDot": "ThemeToggle-module-scss-module__dHZAwW__maskDot",
  "rays": "ThemeToggle-module-scss-module__dHZAwW__rays",
  "toggle": "ThemeToggle-module-scss-module__dHZAwW__toggle",
});
